export { Diagramm } from './diagramm';
